import { createAction, props } from '@ngrx/store';
import { USER_ROLE } from '../reducers/session-info.reducer';
import { AUTHENTICATION_TYPE } from '@xt/domain-model';

export enum NativeClientActions {
  RuntimeBridgeUpdate = '[Session/NativeClient] Runtime Bridge update',
  StartNativeClientSession = '[Session/NativeClient] Set Neccessary Keys',
}

export const runtimeBridgeUpdate = createAction(
  NativeClientActions.RuntimeBridgeUpdate,
  props<{
    user_roles: USER_ROLE[];
    authentication_type?: AUTHENTICATION_TYPE;
  }>(),
);

export const startNativeClientSession = createAction(
  NativeClientActions.StartNativeClientSession,
  props<{
    payload: string;
    user_role: USER_ROLE;
    databaseKey: string;
    matrix_id: string;
  }>(),
);
